import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import Lottie from 'lottie-react';

import successAnimation from '../../../../assets/images/payment/success.json';
import Button from 'Components/Globals/Elements/Button/loadable';
import { composeClassNames, convertRialToToman } from 'Helpers';
import Icon from 'Components/Globals/Elements/Icon/loadable';
import routes from 'Pages/router/constants/routes';
import { walletPaymentActions } from 'Ducks';
import useServices from 'Hooks/useServices';
import useContent from 'Hooks/useContent';

import styles from './styles.module.scss';
import strings from './strings';

const Success = ({ amount }) => {
	const { formatMessage } = useContent();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { business } = useServices();
	const wallets = business?.wallets ?? [];
	const discountPercent =
		wallets.find((w) => w.is_active === true)?.discount_percent || 0;
	const discountAmount = amount ? (amount * discountPercent ?? 0) / 100 : 0;
	const finalAmount = amount ? amount - discountAmount : 0;

	return (
		<div className={composeClassNames(['p-16', styles.success])}>
			<div className={styles.success__content}>
				<Lottie
					animationData={successAnimation}
					loop={true}
					style={{ height: '144px' }}
				/>
				<div
					className={composeClassNames([
						'p-16',
						styles.success__description_wrapper,
					])}
				>
					<div
						className={composeClassNames([
							'p-16',
							styles.success__message_wrapper,
						])}
					>
						<p className='line-height-28 sm bold txt-success-dark'>
							{formatMessage(strings.successDescription)}
						</p>
					</div>

					<div
						className={composeClassNames([
							'ph-16',
							styles.success__detail_wrapper,
						])}
					>
						<div className={styles.success__detail_section}>
							<p className='sm txt-dark line-height-24 bold'>
								{formatMessage(strings.amountTitle)}
							</p>
							<div className={styles.success__amount_wrapper}>
								<p className='txt-dark md line-height-24 bold'>
									{convertRialToToman(amount || '').replaceAll(',', '،')}
								</p>
								<Icon
									name='toman'
									size='xs'
									className='txt-dark'
								/>
							</div>
						</div>
						{discountPercent > 0 && (
							<>
								<div className={styles.success__detail_section}>
									<p className='sm txt-success line-height-24 bold'>
										{formatMessage(strings.discountTitle)} ({discountPercent}%):
									</p>
									<div className={styles.success__amount_wrapper}>
										<p className='txt-success md line-height-24 bold'>
											{convertRialToToman(discountAmount).replaceAll(',', '،')}
										</p>
										<Icon
											name='toman'
											size='xs'
											className='txt-success'
										/>
									</div>
								</div>
								<div className={styles.success__detail_section}>
									<p className='sm txt-dark line-height-24 bold'>
										{formatMessage(strings.finalAmountTitle)}
									</p>
									<div className={styles.success__amount_wrapper}>
										<p className='txt-dark md line-height-24 bold'>
											{convertRialToToman(finalAmount).replaceAll(',', '،')}
										</p>
										<Icon
											name='toman'
											size='xs'
											className='txt-dark'
										/>
									</div>
								</div>
							</>
						)}
					</div>
				</div>
			</div>
			<div className={styles.success__button_wrapper}>
				<Button
					label={formatMessage(strings.tryAgainButton)}
					onClick={() => {
						dispatch(walletPaymentActions.clearAmount());
						navigate(routes.factorAmount);
					}}
					block
					letiant='outline'
					className={styles.success__button}
					color='neutral-gray'
					variant='outline'
				/>
				<Button
					label={formatMessage(strings.backButton)}
					onClick={() => navigate(routes.dashboard)}
					block
					variant='fill'
					className={styles.success__button}
				/>
			</div>
		</div>
	);
};

Success.propTypes = {
	amount: PropTypes.number,
};

export default Success;
